import { isString } from "lodash";
export default class AjaxClass {

    constructor(form, type, url, dataType, dataString) {
        this.form = form;
        this.type = type; // POST || GET
        this.url = url;
        this.dataString = dataString;
        this.dataType = dataType;
    }

    beforeSendFunction() {
        //
    }

    errorFunction(xhr, textStatus, errorThrown) {
        const failMessage = document.querySelector('.fail-message');
        if (failMessage) {
            failMessage.innerHTML = `<div class='danger-box'><i class='fa-solid fa-circle-xmark'></i> Algo deu errado </div>`;
            failMessage.style.display = 'block';
            setTimeout(() => {
                failMessage.style.display = 'none';
            }, 1500);
        }

        const successMessage = document.querySelector('.success-message');
        if (successMessage) {
            successMessage.style.display = 'none';
        }
    }

    completeFunction() {
        //
    }

    successFunction(data, form) {
        const successMessage = document.querySelector('.success-message');
        const failMessage = document.querySelector('.fail-message');

        if (data.status === true) {
            if (successMessage) {
                successMessage.innerHTML = "<div><i class='fa-solid fa-circle-check'></i> <span>Seu cadastro foi realizado<br><b>com sucesso!</b></span></div>";
                successMessage.style.display = 'block';
                setTimeout(() => {
                    successMessage.style.display = 'none';
                }, 1500);
            }

            const formData = new FormData(form);
            formData.forEach((value, name) => {
                const input = form.querySelector(`[name="${name}"]`);
                if (input) {
                    if (input.type === 'checkbox') {
                        input.checked = false;
                    } else {
                        input.value = '';
                    }
                }
            });

            if (failMessage) {
                failMessage.style.display = 'none';
            }
        } else {
            if (failMessage) {
                failMessage.innerHTML = `<div class='danger-box'><i class='fa-solid fa-circle-xmark'></i> ${data.txt} </div>`;
                failMessage.style.display = 'block';
                setTimeout(() => {
                    failMessage.style.display = 'none';
                }, 1500);
            }

            if (successMessage) {
                successMessage.style.display = 'none';
            }
        }
    }

    send() {
        grecaptcha.ready(() => {
            grecaptcha.execute(document.getElementById("recaptcha").value, {
                action: 'submit'
            }).then(token => {
                let processData = true;
                let contentType = 'application/x-www-form-urlencoded; charset=UTF-8';

                if (isString(this.dataString)) {
                    this.dataString += `&gRecaptchaResponse=${token}`;
                } else {
                    this.dataString.append('gRecaptchaResponse', token);
                    processData = false;
                    contentType = null;
                }

                let headers = {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                    'X-Requested-With': 'XMLHttpRequest'
                };

                if (processData) {
                    headers['Content-Type'] = contentType;
                }

                fetch(this.url, {
                    method: this.type,
                    headers: headers,
                    body: this.dataString
                })
                .then(response => response.json())
                .then(data => this.successFunction(data, this.form))
                .catch((xhr, textStatus, errorThrown) => {
                    this.errorFunction(xhr, textStatus, errorThrown);
                })
                .finally(() => {
                    this.completeFunction();
                });
            });
        });
    }

    sendNoRecaptcha() {
        let processData = true;
        let contentType = 'application/x-www-form-urlencoded; charset=UTF-8';

        if (!isString(this.dataString)) {
            processData = false;
            contentType = null;
        }

        let headers = {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'X-Requested-With': 'XMLHttpRequest'
        };

        if (processData) {
            headers['Content-Type'] = contentType;
        }

        let fetchUrl = this.url;
        let fetchOptions = {
            method: this.type,
            headers: headers
        };

        if (this.type.toUpperCase() === 'GET' && isString(this.dataString) && this.dataString) {
            fetchUrl += (fetchUrl.includes('?') ? '&' : '?') + this.dataString;
        } else {
            fetchOptions.body = this.dataString;
        }

        fetch(fetchUrl, fetchOptions)
            .then(response => {
                if (this.dataType === 'html') {
                    return response.text();
                }
                return response.json();
            })
            .then(data => this.successFunction(data, this.form))
            .catch(error => {
                this.errorFunction(error);
            })
            .finally(() => {
                this.completeFunction();
            });
    }
}